module.exports = __webpack_public_path__ + "img/logo-updated.b09a34c6.jpg";